<script>
  import "../app.scss";

  export let data;
</script>

<div>
  <slot {data} />
</div>
